import { sva, cva, css } from "@agapi/ui/panda/css";
export const carouselButtonStyles = cva({
    base: {
        aspectRatio: 1,
        rounded: "50%",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: "1",
        opacity: 0,
        pointerEvents: "none",
        border: "1px solid token(colors.action.secondary.border.default)"
    },
    variants: {
        direction: {
            prev: {
                left: "3",
            },
            next: {
                right: "3",
                transform: "translateY(-50%) rotate(180deg)",
            },
        },
        visible: {
            true: {
                opacity: 0.8,
                pointerEvents: "auto",
            },
        },
    },
});
export const carouselFadeStyles = css.raw({
    transition: "--leftMask 0.18s ease-out, --rightMask 0.18s ease-out",
    maskImage: "linear-gradient(to right, rgba(0, 0, 0, 0) 0px, rgba(0, 0, 0, 1) var(--leftMask), rgba(0, 0, 0, 1) calc(100% - var(--rightMask)), rgba(0, 0, 0, 0) 100%)",
});
export const indicatorStyles = css({
    py: 2,
    display: "flex",
    gap: "1",
    alignItems: "center",
    justifyContent: "center",
});
export const dotStyles = cva({
    base: {
        width: "items.xs",
        height: "items.xs",
        borderRadius: "999px",
        backgroundColor: "surface.primary.tonal.background",
        transition: "0.18s ease-out",
    },
    variants: {
        active: {
            true: {
                width: "items.sm",
                backgroundColor: "surface.primary.vibrant.background",
            }
        }
    }
});
export const carouselStyles = sva({
    slots: ["root", "wrapper", "container", "slide"],
    base: {
        root: {
            position: 'relative',
        },
        wrapper: {
            overflow: "hidden",
            userSelect: "none",
        },
        container: {
            display: "flex",
            gap: "snug",
        },
        slide: {
            flex: "0 0 auto",
            minWidth: "0",
        },
    },
    variants: {
        center: {
            true: {
                container: {
                    justifyContent: 'center',
                }
            }
        },
        fullWidth: {
            true: {
                slide: {
                    flex: "0 0 100%",
                }
            }
        }
    }
});
